import React from 'react'
import Layout from '../Layout'
import ReactHtmlParser from 'react-html-parser'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
export default function howItWorks(props) {
    return (
        <>
            <SEOTAG page="How it Works" />
            <Layout props={props}>
                <div className="px-5 py-4 stctPgWrpr">
                    <span>{ReactHtmlParser(global.storeDetails.how_it_work)}</span>
                </div>
            </Layout>
        </>
    )
}
